module.exports = __webpack_public_path__ + "static/media/liveRamp.f9cd4055.png";